<template>
	<modal @close="closeTutorialModal" :width="1200" name="tutorial" :scrollable="false">
		<div id="tutorial-modal" :class="loaded ? 'loaded' : ''">
			<div class="wrapper">
				<div id="worksends-logo"></div>
				<h2>The modern way to send business gifts.</h2>
				<p class="desc">From every day staff rewards to memorable client thank-yous, 
					shop our fantastic range  of gifts designed for every occasion.</p>
				<div class="actions">
					<span class="ws-button" @click.stop="startTutorial"><strong>Get Started</strong> - It's Free!</span>
					<div class="info">
						<span>Free to use for on demand gifts</span>
						<span>Two minute walkthrough guide</span>
					</div>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
	name: "MarketplaceTutorialModal",
	components: { Modal },
	props: {
	},
	data() {
		return {
			loaded: false,
		}
	},
	methods: {
		startTutorial() {
			this.$store.dispatch('tutorials/startTutorial', 'marketplace');
		},
		closeTutorialModal() {
			this.$store.commit('closeTutorialModal');
		}
	},
	mounted() {
		this.loaded = true;
	},
	computed: {
		modals() {
			return this.$store.state.modals;
		},
		tutorials() {
			return this.$store.state.tutorials;
		},
	}
}
</script>

<style scoped>

</style>